import { render, staticRenderFns } from "./AcceptTerms.vue?vue&type=template&id=4f17cc83"
import script from "./AcceptTerms.vue?vue&type=script&lang=js"
export * from "./AcceptTerms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports